import { Logger } from '../helpers/Logger'
import { capitalize, trim } from '@/common/helpers'

export default {
  props: {
    inputLabel: {
      type: String,
      default: null
    },

    inputName: {
      type: String,
      default: null
    },

    inputPlaceholder: {
      type: String,
      default: null
    },

    modelValue: {
      default: null
    }
  },

  model: {
    prop: 'modelValue',
    event: 'input'
  },

  computed: {
    inputValue: {
      get () {
        return this.modelValue
      },

      set (value) {
        this.emitValue(this.$options.model.event, value)
      }
    }
  },

  watch: {
    inputValue () {
      Logger.log(this.inputValue)
    }
  },

  methods: {
    emit ($event, eventName = null) {
      this.emitValue(eventName || $event.type, $event.target.value)
    },

    emitValue (eventType, value) {
      this.$emit(eventType, value)
    },

    keydown($event) {
      if ($event.target._value === '') {
        if (/[ .,')-]/gi.test($event.key)) {
          $event.preventDefault();

          return
        }
      }
      if (/[^А-ЯЁA-Z .,'()-]/gi.test($event.key)) {
        $event.preventDefault();
      }
    },

    blur () {
      this.inputValue = capitalize(trim(this.inputValue))
    }
  }
}
